import { ref } from 'vue';
import type { Ref } from 'vue';
import type { ComponentExposed } from 'vue-component-type-helpers';
import type { CalculadoraDeCaixa } from './calculadoraDeCaixa';

export class GlobalDialogs {
  fieldSetMercadoria: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputMercadoria: Ref<ComponentExposed<unknown> | null> = ref(null);
  dataFinderMercadoriaRef: Ref<ComponentExposed<unknown> | null> = ref(null);
  labelPesoVariavel: Ref<unknown | null> = ref(null);
  labelValidadePicking: Ref<unknown | null> = ref(null);
  fieldSetLastro: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputLastro: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetCamada: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputCamada: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetNorma: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputNorma: Ref<ComponentExposed<unknown> | null> = ref(null);
  pickingAcondicionadoPaletizacaoDropdown: Ref<ComponentExposed<unknown> | null> = ref(null);
  panelAcondicionamentoSemiAutomatico: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldsetAcondicionaNoPicking: Ref<ComponentExposed<unknown> | null> = ref(null);
  acondicionaPickingSemiAutomaticoDropdown: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetAltura: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputAltura: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetQtdCaixa: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputQtdCaixa: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetEmbalagemPadrao: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputEmbalagemPadrao: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetQtdUnidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputQtdUnidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetFormaRecebimento: Ref<ComponentExposed<unknown> | null> = ref(null);
  formaRecebimentoDropdown: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetQtdTotalUnidades: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputQtdTotalUnidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetMotivoAvaria: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputMotivoAvaria: Ref<ComponentExposed<unknown> | null> = ref(null);
  dataFinderMotivoAvariaRef: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetAvaria: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputQtdAvaria: Ref<ComponentExposed<unknown> | null> = ref(null);
  panelValidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetDataValidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  calendarValidade: Ref<ComponentExposed<unknown> | null> = ref(null);
  fieldSetLoteFabricacao: Ref<ComponentExposed<unknown> | null> = ref(null);
  inputLoteFabricacao: Ref<ComponentExposed<unknown> | null> = ref(null);
  loteFabricacaoDataFinder: Ref<ComponentExposed<unknown> | null> = ref(null);
  confButton: Ref<ComponentExposed<unknown> | null> = ref(null);
}